import { PipeTransform } from '@angular/core';
var FilterPipe = /** @class */ (function () {
    function FilterPipe() {
    }
    FilterPipe.prototype.transform = function (value, args) {
        return args ? value.filter(function (item, index) {
            if (item.tutorName.toLowerCase().indexOf(args.toLowerCase()) != -1 ||
                item.tutorLastName.toLowerCase().indexOf(args.toLowerCase()) != -1 ||
                item.paypalId.toLowerCase().indexOf(args.toLowerCase()) != -1) {
                return true;
            }
        }) : value;
    };
    return FilterPipe;
}());
export { FilterPipe };
//# sourceMappingURL=filter.pipe.js.map